import humanDuration from 'shared/utils/humanDuration'

export default function humanTimestamp(relativeTime, absoluteTime) {
	const formattedRelativeTime = humanDuration(relativeTime)
	const formattedAbsoluteTime = new Date(absoluteTime).toLocaleTimeString('en-GB', {hour12: true})
	return formattedRelativeTime
		? `${formattedRelativeTime} (${formattedAbsoluteTime})`
		: `0 ms (${formattedAbsoluteTime})`
}
